import React from 'react';
interface TrustBarProps {
  variant?: 'light' | 'dark';
}
export function TrustBar({
  variant = 'dark'
}: TrustBarProps) {
  const base = variant === 'dark' ? 'text-white' : 'text-brand-navy';
  return <div className={`flex flex-col items-center justify-center gap-0.5 text-[10.5px] font-bold leading-tight sm:flex-row sm:gap-4 sm:text-xs ${base}`} data-id="element-146" data-mp="y9iiyct27pvq">
      <span data-id="element-147" data-mp="135g2erzmdccq">⭐⭐⭐⭐⭐ 4.9/5 — Recensioni Verificate dagli Istruttori</span>
      <span data-id="element-148" data-mp="1qy69amso15g5">🛡️ Garanzia Soddisfatti o Rimborsati di 14 Giorni — Zero Rischi</span>
    </div>;
}